module.exports = __webpack_public_path__ + "img/hs_logo_white.ad404839.svg";